import React, { Fragment } from "react";

function BackgroundImageCurve({ curveCondition, sources }) {

    // const defaultSrc = 'https://testwww10.eir.ie/opencms/export/sites/default/.galleries/homepage/carousel/curve_png.png'
    const imgSrc = {
        desktop: sources.curveAssetPath != undefined ? sources.curveAssetPath : "",
        mobile: sources.curveMobileAssetPath != undefined ? sources.curveMobileAssetPath : "",
    }
    return (
        <Fragment>
           
            <picture>
              {sources.curveMobileAssetPath != undefined && <source srcSet={imgSrc.mobile} media={"(max-width:767px)"}/>}
                <source srcSet={imgSrc.desktop} media={"(min-width:768px)"}/>
                <img
                src={imgSrc.desktop}
                alt={'image.alt'}
                className={
                    "carousel-slide-curve" + " " + 
                    (curveCondition === "desktop-only" ? "only-desktop" : curveCondition === 'mobile-only' ?  'only-mobile' : '')
                }
            />
            </picture>
        </Fragment>
        
    );
}

export default BackgroundImageCurve;
